import { Component, ViewChild, TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Constructora } from '../../../models/constructora.model';
import { MatDialog } from '@angular/material/dialog';
import {Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng9-rut';
import { FormService } from 'src/app/services/form.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-empresa-constructora",
    templateUrl: "./empresa_constructora.component.html",
    styleUrls: ["./empresa_constructora.component.css"],
    providers: [UserService, FormService]
})

export class EmpresaConstructoraComponent {

    @ViewChild('openModal', { static: true }) openModal:TemplateRef<any>;
    @ViewChild('openModalNODATA', { static: true }) openModalNODATA: TemplateRef<any>;

    public isNatural
    public rut_consta;
    public invalidRut: Boolean;
    public constructora: Constructora;
    public rows = [];
    public actualRow;

    public filteredOptions;
    public nombreComuna = new FormControl('', [ Validators.required]);
    options = []
    public selectedCon:number = null;
    
    public matcher = new FormService();
    constructor(private fb: FormBuilder, private _userService: UserService,
        private rutValidator: RutValidator, private dialog: MatDialog, private spinner: NgxSpinnerService){
            this.rut_consta = this.fb.group({
                rut: ['', [Validators.required, this.rutValidator]]
            })
        if(!JSON.parse(localStorage.getItem("constructora"))){
            localStorage.setItem("constructora", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("constructora"));
        }
        this.invalidRut = true;
            this.constructora = {rut: '',nombre:'', direccion: '',direccion_num:'', direccion_complemento:'', direccion_completa:'',comuna:'',fono:'',fax:'', mail:'', patente:'', recordId:''};
    }


    ngOnInit() {
        this.getComunas()
        this.filteredOptions = this.nombreComuna.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filter(value))
          );
      }

      private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
    
        return this.options.filter(option => option.toLowerCase().includes(filterValue));
      }

    get_Constructora(rut){

        
        this.spinner.show();
        this.cleanData();
        this.cleanData();
        this._userService.getConstructora(rut).subscribe(
            response => {
                if(response.message){
                    this.constructora.rut = rut ? rut : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                } else {
                    this.constructora.rut = response.rut ? response.rut : '';
                    this.constructora.nombre = response.nombre ? response.nombre : '';
                    this.constructora.direccion = response.direccion ? response.direccion : '';
                    this.constructora.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                    this.constructora.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    this.constructora.direccion_num = response.direccion_num ? response.direccion_num : '';
                    this.constructora.comuna = response.comuna ? response.comuna : '';
                    this.constructora.fono = response.fono ? response.fono : '';
                    this.constructora.fax = response.fax ? response.fax : '';
                    this.constructora.mail = response.mail ? response.mail : '';
                    this.constructora.patente = response.patente ? response.patente : '';
                    this.constructora.recordId = response.recordId ? response.recordId : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal);
                    
                }

            },
            error => {
                console.log(error)
                this.spinner.hide();
            }
        )
    }



   
    cleanData(){
        this.constructora = {rut: '',nombre:'', direccion: '',direccion_num:'', direccion_complemento:'', direccion_completa:'',comuna:'',fono:'',fax:'', mail:'', patente:'', recordId:''};
        this.rut_consta.reset()
    }

    update_Constructora(rut, id) {
        this.get_Constructora(rut);
        this.selectedCon = id;
    }


    saveConstructora() {
        window.scroll(0,0);
        //elimina la fila si escriben un rut que ya esté ingresado
        for (let x = 0; x < this.rows.length; x++) {           
            if (this.constructora.rut == this.rows[x].rut) {                
                this.delete_Constructora(x);
            }
        }
        
        //elimina fila cuando la editan
        /*if (this.selectedCon != null) {
            this.delete_Constructora(this.selectedCon);
            this.selectedCon = null;
        }*/

        this.spinner.show();
        this._userService.saveConstructora(this.constructora).subscribe(
            response => {
                this.spinner.hide();

                console.log(response)
                if(response.update || response.save){
                    $("#const_modal").modal("hide");
                    this.actualRow = localStorage.getItem("constructora");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({
                        rut: this.constructora.rut,
                        nombre: this.constructora.nombre,
                        direccion:this.constructora.direccion,
                        direccion_num:this.constructora.direccion_num,
                        direccion_complemento:this.constructora.direccion_complemento,
                        direccion_completa:this.constructora.direccion_completa,
                        comuna:this.constructora.comuna,
                        fono:this.constructora.fono,
                        fax:this.constructora.fax,
                        patente:this.constructora.patente
                       

                    })
                    localStorage.setItem("constructora", JSON.stringify(this.rows));
                    this.constructora = {rut: '',nombre:'', direccion: '',direccion_num:'', direccion_complemento:'', direccion_completa:'',comuna:'',fono:'',fax:'', mail:'', patente:'', recordId:''};
                    this.rut_consta.reset()
                    this.dialog.closeAll();
                    
                }
            },
            error => {
                this.spinner.hide();

                console.log(error)
            }
        )
    }
    delete_Constructora(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("constructora", JSON.stringify(this.rows));
            }
        }
    }

    getComunas() {

        this._userService.getComunas().subscribe(res => {
            //console.log('res', res);
            for (let i = 0; i < res.length; i++) {
                this.options.push(res[i].fieldData.COM_Nombre)
            }

            this.filteredOptions = this.nombreComuna.valueChanges
                .pipe(
                    startWith(''),
                    map(value => this._filter(value))
                );
        }, error => {
            console.log(error)
        })
    }
}